import actions from "./actions";
import state from "./states";
import mutations from "./mutations";

const AdminNoticeModule = {
  namespaced: true,
  actions,
  state,
  mutations,
};

export default AdminNoticeModule;